import { makeStyles } from '@mui/styles';

export const useTimelineSubtextStyles = makeStyles({
  text: {
    fontSize: '14px',
    fontWeight: 200,
    margin: 0
  }
});
